import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import Card from '../../../../../../../shared/Cards/Card'
import TextField from '../../../../../../../shared/Forms/TextField'
import useHttpLoader from '../../../../../../../shared/hooks/useHttpLoader'
import authAtom from '../../../../../../Auth/auth.atom'
import { ITeam, ITeamActiveProject } from '../../../../../teams.types'
import teamsApi from '../../../../../teams.api'
import timeUtils from '../../../../../../../utils/time.utils'

interface IProps {
  team: ITeam
}

const canSeeProjectLink = (user: { userRole: string; isAdmin: boolean } | null): boolean => {
  if (!user) return false
  return user.userRole === 'INSPECTOR' || user.userRole === 'ADMIN' || user.isAdmin === true
}

const TeamInfoCard = (props: IProps) => {
  const { team } = props
  const navigate = useNavigate()
  const currentUser = useRecoilValue(authAtom).user
  const { wait, loading } = useHttpLoader()
  const [activeProject, setActiveProject] = useState<ITeamActiveProject | null>(null)
  const showProjectLink = canSeeProjectLink(currentUser)

  useEffect(() => {
    if (!showProjectLink || !team.id) return
    wait(teamsApi.getActiveProject(team.id), (resp) => {
      if (resp.status === 'success') setActiveProject(resp.body.project)
    })
  }, [showProjectLink, team.id])

  return (
    <Card type='normal'>
      <div className='flex-lines'>
        <div style={{ marginBottom: '16px' }} className={showProjectLink ? 'flex-space-between' : undefined}>
          <h2 className='text--caption-l text-700'>О команде</h2>
          {showProjectLink && (
            <>
              {loading ? (
                <span className='text--body-m text--secondary'>Загрузка...</span>
              ) : activeProject ? (
                <span
                  className='text--link text--link-underline'
                  onClick={() => navigate(`/projects/${activeProject.id}`)}
                  role='link'
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && navigate(`/projects/${activeProject.id}`)}
                >
                  Посмотреть информацию о проекте
                </span>
              ) : null}
            </>
          )}
        </div>
        <TextField header='Название'>{team.name}</TextField>
        <div className='grid-form-2'>
          <TextField header='Создана'>{timeUtils.formatDate(new Date(team.createdAt), 'dd MMM yyyy')}</TextField>
          <TextField header='Обновлена'>{timeUtils.formatDate(new Date(team.updatedAt), 'dd MMM yyyy')}</TextField>
        </div>
      </div>
    </Card>
  )
}

export default TeamInfoCard
